import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Card, Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './IntegrationCard.module.scss';
export const GetIntegrationCardTID = (parentTestId)=>getTestIds(parentTestId);
export default function IntegrationCard(props) {
    const { testId, icon, title, subTitle, mainAction, disclaimer } = props;
    const { IntegrationCardTID } = useMemo(()=>GetIntegrationCardTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Card, {
        bi: {
            name: 'integration_card',
            data: {
                test_id: testId !== null && testId !== void 0 ? testId : ''
            }
        },
        testId: testId,
        className: styles.card,
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                gap: 12,
                alignItems: "start",
                children: [
                    icon,
                    /*#__PURE__*/ _jsxs(Column, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ _jsxs(Column, {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        weight: "normal",
                                        children: title
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        testId: testId && "".concat(testId, "-sub-title"),
                                        variant: 'paragraph2',
                                        skin: "secondary",
                                        children: subTitle
                                    })
                                ]
                            }),
                            disclaimer && /*#__PURE__*/ _jsx(Typography, {
                                testId: IntegrationCardTID.Disclaimer(),
                                variant: 'paragraph3',
                                skin: "secondary",
                                children: disclaimer
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Column, {
                alignItems: "start",
                children: mainAction
            })
        ]
    });
}
IntegrationCard.MainActionButton = (props)=>/*#__PURE__*/ _jsx(Button, _object_spread({
        size: "small"
    }, props));
